import { watch } from 'vue';
import { defineStore } from 'pinia'
import API from '@/services/api';

import {
  SearchKey
} from "@/interfaces/data-contracts";


const useClaimStore = defineStore("SearchStore", {
  state: () => {
    return {
      searchKey: null as SearchKey | null,
    }
  },
  actions: {
    async refreshKey() {
      const searchKey = await API.getScopedKey();
      if (searchKey?.securedApiKey) {
        this.searchKey = searchKey
      }
      return searchKey;
    }
  }
});

export default useClaimStore;